export const content = {
  firstNameHeading: 'First name',
  lastnameHeading: 'Last name',
  emailHeading: 'Email',
  dobHeading: 'Date of birth',
  signupContinue: 'Continue',
};
